import { useEffect, useState } from "react";
import MessageItem from "@/components/community/MessageItem";

export default function PinnedPanel({ api, base, tick, me }) {
  const [items, setItems] = useState(null);
  useEffect(() => {
    api.get(`${base}/pinned`).then(({ data }) => setItems(data.messages)).catch(() => setItems([]));
  }, [api, base, tick]);
  return (
    <div className="border-b border-[#262626] bg-[#0D0D0D] px-2 sm:px-4 py-3 max-h-72 overflow-y-auto" data-testid="community-pinned-panel">
      <div className="font-mono-label text-[10px] text-[#FFD600] mb-2 px-2">PINNED RESOURCES</div>
      {items?.length === 0 && <p className="text-xs text-muted-foreground px-2" data-testid="community-pinned-empty">Nothing pinned yet. The CarrierLaunch team pins the most useful posts here.</p>}
      {items?.map((m) => <MessageItem key={m.id} api={api} msg={m} me={me} compact />)}
    </div>
  );
}
